import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "src/app/Service/notification.service";
import { OtherService } from "src/app/Service/other.service";
import { Point } from "ol/geom";
import { BingMaps, Cluster, Vector, XYZ } from "ol/source";
import { MapService } from "src/app/Service/map.service";
import { Circle, Fill, Stroke, Style, Text } from "ol/style";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { GurdServiceService } from "src/app/Service/gurd-service.service";
import "ol/ol.css";
import Map from 'ol/Map';
import View from 'ol/View';
import Feature from 'ol/Feature';
import OSM from 'ol/source/OSM';
import Chart from 'chart.js/auto';
import axios from "src/app/Service/axios";
import AnimatedCluster from "ol-ext/layer/AnimatedCluster";
import SelectCluster from "ol-ext/interaction/SelectCluster";
import * as olProj from 'ol/proj';
import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
declare let $: any;
@Component({

  selector: 'app-taxi-status-dashboard',

  templateUrl: './taxi-status-dashboard.component.html',

  styleUrls: ['./taxi-status-dashboard.component.css']

})

export class TaxiStatusDashboardComponent implements OnInit {

  map: any = {};

  map2: any = {};

  map3: any = {};

  source: any;

  source2: any;

  source3: any;

  vector: any;

  vector2: any;

  vector3: any;

  layers: any = [];

  layers2: any = [];

  layers3: any = [];

  location: any = [51.3833554, 35.6770113];

  lst_ActiveTaxi = [];

  lst_ActiveTaxi_Search = [];

  lst_CarStatus = [];

  lst_Deactive = [];

  lst_Deactive_Search = [];

  lst_Search = [];

  lst_Search2 = [];

  lst_Vacation = [];

  lst_Vacation_Search = [];

  ctx1: any;

  obj1: any;

  label1: Array<any> = [];

  datachart1: Array<any> = [];

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  CHART_COLORS: any = {
    green: 'rgb(111, 255, 111)',
    purple: 'rgb(255, 153, 204)',
    blue: 'rgb(29, 179, 214)',
    orange: 'rgb(45, 103, 103)',
    yellow: 'rgb(251, 101, 150)',
    red: 'rgb(36, 123, 46)',
    grey: 'rgb(103, 13, 183)',
  };

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private mapService: MapService

  ) { }

  ngOnInit(): void {

    this.get_TaxiDashboard();

  }

  async get_TaxiDashboard() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Taxi_LiveDashboard_CurrentStatus`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '5x7' } });

      return;

    }

    if (res.iResult == 0) {

      this._tooltip.showError(res.strError);

      return;

    }

    this.lst_ActiveTaxi = res.Active;

    this.lst_ActiveTaxi_Search = res.Active;

    this.initializeMap(this.lst_ActiveTaxi, 'activeFleetMap');

    this.lst_CarStatus = res.CarStatus;

    this.carStatus_Chart(res.CarStatus);

    this.lst_Deactive = res.UnActive;

    this.lst_Deactive_Search = res.UnActive;

    this.initializeMap2(this.lst_Deactive, 'absenceFleetMap');

    this.lst_Search = res.UnActive;

    this.lst_Vacation = res.Vacation;

    this.lst_Vacation_Search = res.Vacation;

    this.initializeMap3(this.lst_Vacation, 'vacationFleetMap');

    this.lst_Search2 = res.Vacation;

  }

  carStatus_Chart = async (resParse: any) => {

    this.obj1 = resParse;

    this.obj1.forEach((element: any) => {

      this.label1.push(element.X);

      this.datachart1.push(element.Y);

    });

    var canvas = document.getElementById("myChart1") as any;

    var ctx = canvas.getContext("2d");

    const DATA_COUNT = 5;

    const data = {

      labels: this.label1,

      datasets: [

        {
          data: this.datachart1,

          backgroundColor: Object.values(this.CHART_COLORS),

        },
      ],

    } as any;

    if (this.ctx1) {

      this.ctx1.destroy();

    }

    this.ctx1 = new Chart(ctx, {

      type: 'pie',

      data: data,

      options: {

        onClick: (e) => {

          // const points = this.ctx1.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);

          // const firstPoint = points[0];

          // const label = this.ctx1.data.labels[firstPoint.index];

          // const value = this.ctx1.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];

          // this.fileName = "نمودارد وضعیت خودروها.xlsx";

          // this.carStatus(1, label);

        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          legend: {
            position: 'top',
            labels: {
              color: "black",
            }
          },
          title: {
            display: false,
          },
        },

      },
    });

    var chartEl = document.getElementById("myChart1") as any;

    chartEl.height = 200;

  }

  filter_list(val: any) {

    this.lst_Deactive = this.lst_Search.filter((el: any) => {

      return el?.strBusLineCode?.toString().includes(val.value) ||

        el.strBusLineName?.toString().includes(val.value) ||

        el.strFullName?.toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Deactive = this.lst_Search;

    }

  }

  filter_list2(val: any) {

    this.lst_Vacation = this.lst_Search2.filter((el: any) => {

      return el?.strBusLineCode?.toString().includes(val.value) ||

        el.strBusLineName?.toString().includes(val.value) ||

        el.strFullName?.toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Vacation = this.lst_Search2;

    }

  }

  filter_list3(val: any) {

    this.lst_ActiveTaxi = this.lst_ActiveTaxi_Search.filter((el: any) => {

      return el?.strBusLineCode?.toString().includes(val.value) ||

        el.strBusLineName?.toString().includes(val.value) ||

        el.strFullName?.toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_ActiveTaxi = this.lst_ActiveTaxi_Search;

    }

    this.initializeMap(this.lst_ActiveTaxi, 'activeFleetMap');

  }

  filter_list4(val: any) {

    this.lst_Deactive = this.lst_Deactive_Search.filter((el: any) => {

      return el?.strBusLineCode?.toString().includes(val.value) ||

        el.strBusLineName?.toString().includes(val.value) ||

        el.strFullName?.toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Deactive = this.lst_Deactive_Search;

    }

    this.initializeMap2(this.lst_Deactive, 'absenceFleetMap');
  }

  filter_list5(val: any) {

    this.lst_Vacation = this.lst_Vacation_Search.filter((el: any) => {

      return el?.strBusLineCode?.toString().includes(val.value) ||

        el.strBusLineName?.toString().includes(val.value) ||

        el.strFullName?.toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Vacation = this.lst_Vacation_Search;

    }

    this.initializeMap3(this.lst_Vacation, 'vacationFleetMap');

  }

  openDetails(item) {

    window.open(`/carInfo/${item.strUnitID}`, '_blank');

  }

  initializeMap = async (resParse, id: string) => {

    setTimeout(() => {

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {
          this.layers.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)
      }

      if (this.map?.frameIndex_) {

        this.map.setTarget(null);

      }

      this.map = new Map({

        target: id,

        view: new View({

          zoom: 9,

          center: olProj.fromLonLat(this.location)

        }),

        layers: this.layers

      });

      this.clustersLayer(resParse);

    }, 300);

  }

  initializeMap2 = async (resParse, id: string) => {

    setTimeout(() => {

      this.source2 = new VectorSource({ wrapX: false });

      this.vector2 = new VectorLayer({

        source: this.source2,

      });

      if (this.bOfflineMap) {

        this.layers2.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {
          this.layers2.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
        }

        this.layers2.push(new TileLayer({ source: new OSM({}) }), this.vector2)
      }

      if (this.map2?.frameIndex_) {

        this.map2.setTarget(null);

      }

      this.map2 = new Map({

        target: id,

        view: new View({

          zoom: 9,

          center: olProj.fromLonLat(this.location)

        }),

        layers: this.layers2

      });

      this.clustersLayer2(resParse);

    }, 300);

  }

  initializeMap3 = async (resParse, id: string) => {

    setTimeout(() => {

      this.source3 = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source3,

      });

      if (this.bOfflineMap) {

        this.layers3.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {
          this.layers3.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
        }

        this.layers3.push(new TileLayer({ source: new OSM({}) }), this.vector3)
      }

      if (this.map3?.frameIndex_) {

        this.map3.setTarget(null);

      }

      this.map3 = new Map({

        target: id,

        view: new View({

          zoom: 9,

          center: olProj.fromLonLat(this.location)

        }),

        layers: this.layers3

      });

      this.clustersLayer3(resParse);

    }, 300);

  }

  clustersLayer(data: any) {
    setTimeout(() => {
      this.map.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }

        var el = this.mapService.mapPointerMove(
          this.map.getEventPixel(e.originalEvent),
          this.map
        );
        this.showData(el);
        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.map.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;

    // Addfeatures to the cluster
    let addFeatures = (nb: any) => {
      var ext = this.map.getView().calculateExtent(this.map.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([data[i].dLongitude, data[i].dLatitude])

          ),

          id_: data[i].strUnitID,

          data: {

            Id: data[i].strUnitID,

            strFullName: data[i].strFullName,

            strMobile: data[i].strMobile,

          },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();
      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.map.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.map.addInteraction(selectCluster);


  }

  clustersLayer2(data: any) {
    setTimeout(() => {
      this.map2.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }

        var el = this.mapService.mapPointerMove(
          this.map2.getEventPixel(e.originalEvent),
          this.map2
        );
        this.showData(el);
        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.map2.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;

    // Addfeatures to the cluster
    let addFeatures = (nb: any) => {
      var ext = this.map2.getView().calculateExtent(this.map2.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([data[i].dLongitude, data[i].dLatitude])

          ),

          id_: data[i].strUnitID,

          data: {

            Id: data[i].strUnitID,

            strFullName: data[i].strFullName,

            strMobile: data[i].strMobile,

          },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();
      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.map2.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.map2.addInteraction(selectCluster);


  }

  clustersLayer3(data: any) {
    setTimeout(() => {
      this.map3.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }

        var el = this.mapService.mapPointerMove(
          this.map3.getEventPixel(e.originalEvent),
          this.map3
        );
        this.showData(el);
        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.map3.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;

    // Addfeatures to the cluster
    let addFeatures = (nb: any) => {
      var ext = this.map3.getView().calculateExtent(this.map3.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([data[i].dLongitude, data[i].dLatitude])

          ),

          id_: data[i].strUnitID,

          data: {

            Id: data[i].strUnitID,

            strFullName: data[i].strFullName,

            strMobile: data[i].strMobile,

          },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();
      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.map3.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.map3.addInteraction(selectCluster);


  }

  showData(item: any) {

    var tooltip = $('#map_tooltip');

    tooltip.tooltip({

      html: true,

      animation: true,

      trigger: 'manual',

      placement: 'top',

    });

    tooltip.css({

      left: item.pixel[0] + 'px',

      top: item.pixel[1] - 14 + 'px',

      zindex: 1000,

    });

    if (item.featureLayer) {

      if (item.featureLayer.feature) {

        if (item.featureLayer.feature.values_.features.length == 1) {

          if (item.featureLayer.feature.values_.features[0].values_.data.strFullName) {

            const car = item.featureLayer.feature.values_.features[0].values_.data;

            window.open(`/carInfo/${car.Id}`, '_blank');


          }

        }

      }

    }

    else {

      tooltip.tooltip('hide');

    }

  }


}
